import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import portalAxios from "../portalAxios";
import { MemberErasurePreviewResponse } from "../../members/contracts/MemberErasurePreviewResponse";
import { KeptTrainingRecord } from "../../members/models/MemberErasure";
import { toKeptTrainingRecords } from "../../members/mappers/MemberErasureMapper";

/**
 * What a deletion request for the member (self or ward) would keep under legal hold (PD-0021),
 * read when the portal's "Delete my data" confirmation opens.
 */
export const fetchPortalErasurePreview = createAsyncThunk<
  KeptTrainingRecord[],
  string,
  { rejectValue: ApiErrorResponse }
>("portal/fetchErasurePreview", async (memberId, { rejectWithValue }) => {
  try {
    const response = await portalAxios.get<MemberErasurePreviewResponse>(
      `/portal/members/${memberId}/erasure-preview`
    );
    return toKeptTrainingRecords(response.data);
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});
